import onResize from '../utils/onResize'
import { get } from '@bigyouth/base'

export default {
  name: 'full-height-mobile',

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.onResize()
    this.calcHeight()

    window.addEventListener('orientationchange', () => {
      this.calcHeight()
    })
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.calcHeight()
  },

  calcHeight () {
    let height = window.innerHeight
    let topBanner = get('.top-banner')

    if (topBanner) {
      height -= topBanner.offsetHeight
    }

    let vh = height * 0.01
    this.el.style.setProperty('--vh', `${vh}px`)
  },
}
